import { THEME_COLOR } from "../../../utils/consts";
import dark from "./dark";
import light from "./light";

export const lightTheme = { ...light };

export const darkTheme = { ...dark };

export const THEME_STORAGE_KEY = "theme";

export const THEME_SWITCHING_CLASS = "theme-switching";

export const getInitialThemeName = () => {
  const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);

  if (storedTheme === THEME_COLOR.LIGHT || storedTheme === THEME_COLOR.DARK) {
    return storedTheme;
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches ? THEME_COLOR.DARK : THEME_COLOR.LIGHT;
};

export const getThemeByName = (themeName) => themeName === THEME_COLOR.DARK ? darkTheme : lightTheme;